import { lazy } from 'react'
import { Helmet } from 'react-helmet'

const DVRApp = lazy(() => import(/* webpackChunkName: "dvr" */ './dvr-app'))

const DVRRoute = props => (
    <>
        <Helmet>
            <title>GIPHY | Super Cut</title>
        </Helmet>
        <DVRApp {...props} />
    </>
)

export default DVRRoute
